export default __webpack_public_path__ + "static/media/acropass-spot-eraser-vita-temporary.93a87c06.png";